import React from 'react';
import { Container, Col, Row } from 'reactstrap';
import ShippingToolsAmazonPage from './components/ShippingToolsAmazonPage';


const ShippingToolsAmazon = () => (
  <Container>
    <Row>
      <Col md={12}>
        <h5 className="page-title">Tools / Shipping / Amazon</h5>
      </Col>
    </Row>
    <Row>
      <ShippingToolsAmazonPage />
    </Row>
  </Container>
);

export default ShippingToolsAmazon;
